const toPositiveInteger = (value) => {
  const normalized = Number(value);
  return Number.isInteger(normalized) && normalized > 0 ? normalized : null;
};

export function resolveOrderCoverQuantity({
  existingQuantity,
  confirmedQuantity,
  draftQuantity,
  enteredQuantity,
  tableTakenSeats,
  tableMaxSeats,
}) {
  const candidates = [
    existingQuantity,
    confirmedQuantity,
    draftQuantity,
    enteredQuantity,
    tableTakenSeats,
    tableMaxSeats,
    1,
  ];

  return candidates.map(toPositiveInteger).find((value) => value !== null) || 1;
}
